import type { SITE_DETAILS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-details-card/site-details-card.fr.ts";

export const SITE_DETAILS_CARD_ENGLISH_LOCALE = {
  title: "Site",
  phoningMission: "Mission",
  siteId: "Site Id",
  externalId: "External Id",
  companyName: "Company name",
  address: "Address",
  subscribedPower: "Subscribed power",
  layoutType: "Site type",
  layout: "Site type layout",
  surface: "Surface",
} satisfies typeof SITE_DETAILS_CARD_FRENCH_LOCALE;
